import { connect } from "socket.io-client";

const port = getOverridePort() || Config.port.game;
const connectionPath = Config.port.server_url ? Config.port.server_url : Config.app_root + ':' + port;

const socket = connect(connectionPath, {
    transports: Config.port.transports.split(','),
});

socket.on('connection', authenticate);

socket.on('multiple_sessions', () => {
    location.replace(Config.route.multiple_sessions);
});

socket.on('apiError', e => {
    parent.postMessage({ ...e, api_error: true }, '*');
});

setInterval(renew, 30e3);

function authenticate() {
    const params = {
        id: Config.player_id,
        shop: Config.shop_id,
        token: Config.token,
        type: Config.type,
    };

    socket.emit('auth', params);
}

function renew() {
    socket.emit('renewSocketToken', {}, ({ token }) => {
        Config.token = token;
    });
}

function getOverridePort() {
    let port = undefined;
    try {
        port = localStorage.getItem('game_socket_port');
    } catch (e) {

    }
    return port;
}

export default socket;